/**
 * Tiny presentational primitives shared across Summary sub-components.
 * `Block` is the bordered card container; `BulletBlock` renders an ordered or
 * unordered list inside a block (or inline within another card).
 */

export function Block({ title, children }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6">
      <h3 className="font-display text-xl font-semibold text-slate-900 tracking-tight">{title}</h3>
      <div className="mt-3">{children}</div>
    </div>
  );
}

export function BulletBlock({ title, items, ordered = false, inline = false }) {
  if (!items || !items.length) return null;
  const Tag = ordered ? "ol" : "ul";
  if (inline) {
    return (
      <div className="mt-4">
        <p className="text-[11px] uppercase tracking-[0.12em] text-slate-500">{title}</p>
        <Tag className={`${ordered ? "list-decimal" : "list-disc"} list-inside mt-1.5 space-y-1 text-sm text-slate-700`}>
          {items.map((it, idx) => <li key={`${idx}-${String(it).slice(0, 40)}`}>{it}</li>)}
        </Tag>
      </div>
    );
  }
  return (
    <Block title={title}>
      <Tag className={`${ordered ? "list-decimal" : "list-disc"} list-inside space-y-2 text-slate-700 leading-relaxed`}>
        {items.map((it, idx) => <li key={`${idx}-${String(it).slice(0, 40)}`}>{it}</li>)}
      </Tag>
    </Block>
  );
}
